module.exports = "<svg width=\"27\" height=\"24\" viewBox=\"0 0 27 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.865 18.545H5.978L1.943 23.59c-.212.265-.527.41-.852.41-.12 0-.242-.02-.36-.06-.438-.155-.73-.567-.73-1.03V4.316C0 1.937 1.936 0 4.318 0h17.547c2.38 0 4.317 1.936 4.317 4.317v9.912c0 2.38-1.937 4.315-4.317 4.315z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false?remoteTags=true!./src/images/svg/chat.svg
// module id = yfY0
// module chunks = 89